import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    agentsUpdated,
    bdsUpdated,
    clientsUpdated,
    custodiansUpdated,
    getAgentsError,
    getBdsError,
    getClientsError,
    getCustodiansError,
    getGroupsError,
    getRiasError,
    groupsUpdated,
    riasUpdated
} from "./actions";
import {GET_AGENTS, GET_BDS, GET_CLIENTS, GET_CUSTODIANS, GET_GROUPS, GET_RIAS} from "./actionTypes";
import {getCustodians} from "../../helpers/info";
import {getBds} from "../../helpers/bds";
import {getRias} from "../../helpers/rias";
import {getAgents} from "../../helpers/agents";
import {getClients} from "../../helpers/clients";
import {getGroups} from "../../helpers/groups";

function* getCustodiansSaga() {
    try {
        const response = yield call(getCustodians);
        yield put(custodiansUpdated(response));
    } catch (error) {
        console.error(error);
        yield put(getCustodiansError(error));
    }
}

function* getBdsSaga() {
    try {
        const response = yield call(getBds);
        yield put(bdsUpdated(response));
    } catch (error) {
        console.error(error);
        yield put(getBdsError(error));
    }
}

function* getRiasSaga() {
    try {
        const response = yield call(getRias);
        yield put(riasUpdated(response));
    } catch (error) {
        console.error(error);
        yield put(getRiasError(error));
    }
}

function* getAgentsSaga() {
    try {
        const response = yield call(getAgents);
        yield put(agentsUpdated(response));
    } catch (error) {
        console.error(error);
        yield put(getAgentsError(error));
    }
}

function* getClientsSaga() {
    try {
        const response = yield call(getClients);
        yield put(clientsUpdated(response));
    } catch (error) {
        console.error(error);
        yield put(getClientsError(error));
    }
}

function* getGroupsSaga() {
    try {
        const response = yield call(getGroups);
        yield put(groupsUpdated(response));
    } catch (error) {
        console.error(error);
        yield put(getGroupsError(error));
    }
}

export function* watchGetCustodiansSaga() {
    yield takeEvery(GET_CUSTODIANS, getCustodiansSaga);
}

export function* watchGetBdsSaga() {
    yield takeEvery(GET_BDS, getBdsSaga);
}

export function* watchGetRiasSaga() {
    yield takeEvery(GET_RIAS, getRiasSaga);
}

export function* watchGetAgentsSaga() {
    yield takeEvery(GET_AGENTS, getAgentsSaga);
}

export function* watchGetClientsSaga() {
    yield takeEvery(GET_CLIENTS, getClientsSaga);
}

export function* watchGetGroupsSaga() {
    yield takeEvery(GET_GROUPS, getGroupsSaga);
}

function* infoSaga() {
    yield all([
        fork(watchGetCustodiansSaga),
        fork(watchGetBdsSaga),
        fork(watchGetRiasSaga),
        fork(watchGetAgentsSaga),
        fork(watchGetClientsSaga),
        fork(watchGetGroupsSaga)
    ]);
}

export default infoSaga;
